import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Car, LayoutDashboard, LogOut, Shield } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-emerald-900/10 shadow-sm"
      data-testid="navbar"
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="nav-logo">
          <span className="h-9 w-9 rounded-xl overflow-hidden ring-1 ring-emerald-900/10 shadow-sm">
            <img src="/logo.png" alt="Accurate Auto Rentals logo" className="h-full w-full object-cover scale-[1.18]" />
          </span>
          <span className="font-display font-extrabold text-lg tracking-tight text-emerald-950 leading-none">
            Accurate Auto<span className="text-emerald-500"> Rentals</span>
          </span>
        </Link>

        <div className="flex items-center gap-1 sm:gap-2">
          <Link
            to="/fleet"
            className="px-3 py-2 text-sm font-medium text-slate-600 hover:text-emerald-700 transition-colors"
            data-testid="nav-fleet"
          >
            Our Fleet
          </Link>

          {user ? (
            <>
              {user.role === "admin" ? (
                <Button variant="ghost" size="sm" onClick={() => navigate("/admin")} data-testid="nav-admin" className="text-slate-700">
                  <Shield size={16} className="mr-1.5" /> Admin
                </Button>
              ) : (
                <Button variant="ghost" size="sm" onClick={() => navigate("/dashboard")} data-testid="nav-dashboard" className="text-slate-700">
                  <LayoutDashboard size={16} className="mr-1.5" /> Dashboard
                </Button>
              )}
              <Button size="sm" variant="outline" onClick={handleLogout} data-testid="nav-logout" className="border-slate-200">
                <LogOut size={16} className="mr-1.5" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/login")} data-testid="nav-login" className="text-slate-700">
                Sign in
              </Button>
              <Button
                size="sm"
                onClick={() => navigate("/register")}
                data-testid="nav-register"
                className="bg-emerald-900 hover:bg-emerald-800 text-white rounded-full px-5"
              >
                Get Started
              </Button>
            </>
          )}
        </div>
      </nav>
    </header>
  );
};
